package com.havn.app.core.platform

actual fun playHavnKioskRecognitionBell() = Unit
